import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Holiday() {
  const [activeModal, setActiveModal] = useState(null);
  const [holidaydata, setHolidaydata] = useState([]);

  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  // Add Form States
  const [holidaytitle, setHolidayTitle] = useState("");
  const [holidaydate, setHolidayDate] = useState("");
  const [holidaydescription, setHolidayDescription] = useState("");
  const [holidaystatus, setHolidayStatus] = useState("");

  // ✅ GET from LocalStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("holidays")) || [];
    setHolidaydata(stored);
  }, []);

  // ✅ Save Helper
  const saveToLocalStorage = (data) => {
    localStorage.setItem("holidays", JSON.stringify(data));
  };

  // ✅ CREATE
  const holidayCreate = (e) => {
    e.preventDefault();

    const newHoliday = {
      _id: Date.now(),
      title: holidaytitle,
      description: holidaydescription,
      date: holidaydate,
      status: holidaystatus,
    };

    const updated = [...holidaydata, newHoliday];

    setHolidaydata(updated);
    saveToLocalStorage(updated);

    // Reset form
    setHolidayTitle("");
    setHolidayDate("");
    setHolidayDescription("");
    setHolidayStatus("");

    setActiveModal(null);
  };

  // ✅ EDIT
  const handleEdit = (holiday) => {
    setEditId(holiday._id);
    setEditForm({
      title: holiday.title,
      description: holiday.description,
      date: holiday.date,
      status: holiday.status,
    });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditForm({});
  };

  // ✅ UPDATE
  const handleSave = (id) => {
    const updated = holidaydata.map((h) =>
      h._id === id ? { ...h, ...editForm } : h,
    );

    setHolidaydata(updated);
    saveToLocalStorage(updated);

    setEditId(null);
    setEditForm({});
  };

  // ✅ DELETE
  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this holiday?"))
      return;

    const updated = holidaydata.filter((h) => h._id !== id);
    setHolidaydata(updated);
    saveToLocalStorage(updated);
  };

  // ✅ SORT (optional)
  const sortedData = [...holidaydata].sort(
    (a, b) => new Date(a.date) - new Date(b.date),
  );

  return (
    <>

     <div className="page-header-tap">
              <h3>Holiday</h3>
    
              <div>
        
                        <button
                onClick={() => setActiveModal("addholiday")}
              
                style={{ width: "max-content", margin: "0px 10px" }}
                 className="addbtn"
              >
                + Add Holiday
              </button>
              </div>
            </div>
      {/* MODAL */}
      {activeModal === "addholiday" && (
        <div className="modal">
          <form className="modal-content" onSubmit={holidayCreate}>
            <h3>Add Holiday</h3>
            <div class="formlabeldiv">
              <input
                type="text"
              
                value={holidaytitle}
                onChange={(e) => setHolidayTitle(e.target.value)}
                required
              /> <label>Title</label>
            </div>

            <div class="formlabeldiv">
              <input
                type="date"
                value={holidaydate}
                onChange={(e) => setHolidayDate(e.target.value)}
                required
              /> <label>Date</label>
            </div>

            <div class="formlabeldiv">
              <input
                type="text"
               
                value={holidaydescription}
                onChange={(e) => setHolidayDescription(e.target.value)}
                required
              /> <label>Description</label>
            </div>
            <div class="formlabeldiv">
              <select
                value={holidaystatus}
                onChange={(e) => setHolidayStatus(e.target.value)}
                required
              >
                <option value="" disabled>Select Status</option>
                <option value="festivals">Festivals</option>
                <option value="weeklyoff">Weekly Off</option>
                <option value="halfday">Half Day</option>
              </select>
              <label>Status</label>
            </div>

            <div
              style={{
                marginTop: "10px",
                width: "100%",
                display: "grid",
                rowGap: "10px",
              }}
            >
              <button type="submit" className="button">
                Save
              </button>
              <button
                type="button"
                onClick={() => setActiveModal(null)}
                className="statusbox red-bg"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div>
        {/* TABLE */}
        <div className="table-div" style={{ marginTop: "20px" }}>
          <div className="table-header">
            <h5>Holiday list</h5>
         
          </div>

          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {sortedData.map((h) => (
                  <tr key={h._id}>
                    <td>
                      {editId === h._id ? (
                        <input
                          value={editForm.title}
                          onChange={(e) =>
                            setEditForm({ ...editForm, title: e.target.value })
                          }
                        />
                      ) : (
                        h.title
                      )}
                    </td>

                    <td>
                      {editId === h._id ? (
                        <input
                          type="date"
                          value={editForm.date}
                          onChange={(e) =>
                            setEditForm({ ...editForm, date: e.target.value })
                          }
                        />
                      ) : (
                        new Date(h.date).toLocaleDateString()
                      )}
                    </td>

                    <td>
                      {editId === h._id ? (
                        <input
                          value={editForm.description}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              description: e.target.value,
                            })
                          }
                        />
                      ) : (
                        h.description
                      )}
                    </td>

                    <td>
                      {editId === h._id ? (
                        <select
                          value={editForm.status}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              status: e.target.value,
                            })
                          }
                        >
                          <option value="festivals">Festivals</option>
                          <option value="weeklyoff">Weekly Off</option>
                          <option value="halfday">Half Day</option>
                        </select>
                      ) : (
                        h.status
                      )}
                    </td>

                    <td>
                      {editId === h._id ? (
                        <>
                          <button
                            onClick={() => handleSave(h._id)}
                            className="statusbox green-bg"
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancel}
                            className="statusbox red-bg"
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => handleEdit(h)}
                            className="statusbox green-bg"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(h._id)}
                            className="statusbox red-bg"
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}

                {holidaydata.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No holidays found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Holiday;
